/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { DatePipe } from '@angular/common';
import { Component, DoCheck, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AbstractObject } from '@src/app/model/abstract-object';
import { DateTimeField } from '@src/app/shared/form/form-date-time/form-date-time.component';

@Component({
    selector: 'app-date-time-table-cell',
    imports: [MatTooltipModule, DatePipe],
    templateUrl: './date-time-table-cell.component.html',
    styleUrl: './date-time-table-cell.component.scss'
})
export class DateTimeTableCellComponent implements DoCheck {
    @Input({required: true}) field: DateTimeField
    @Input({required: true}) focusItem: AbstractObject

    relativeToNowText = '';

    /** Read the clock in ngDoCheck, not from the template: dev mode's checkNoChanges pass skips
     *  lifecycle hooks, so both passes see the same text even when a minute rolls over between them. */
    ngDoCheck() {
        this.relativeToNowText = this.field.getFormattedValue(this.focusItem);
    }
}
